/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface TempID
 */
export interface TempIDOptional {
  /**
   *
   * @type {string}
   * @memberof TempID
   */
  tempID?: string;
}

export interface TempID extends TempIDOptional {
  /**
   *
   * @type {string}
   * @memberof TempID
   */
  tempID?: string;
}

export interface TempIDTrackedI {
  /**
   *
   * @type {string}
   * @memberof TempID
   */
  tempID?: string;
  tempIDIsSet: boolean;
}

transformDatesMap.set("TempID", function (model: TempID) {});

export type TempIDMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
}>;

export var TempIDMeta: TempIDMetaI = {} as TempIDMetaI;
TempIDMeta = typeMeta("TempID", {
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
});

const metaI = TempIDMeta;

registerMeta(() => {});

export class TempIDTracked implements TempIDTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  constructor(config?: TempIDOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {}
  assignFrom(config: TempIDOptional, options?: AssignOptions): TempIDTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): TempIDTrackedI {
    const cloned = {} as TempIDTrackedI;
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): TempIDTrackedI {
    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    return this;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TempIDMeta.tempID, TempIDMeta, this.tempID, this);
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
